import { AsapBaseService } from './asap-base.service';
import { Global } from './global';
import { AsapEditComponent } from './asap-edit.component';

import Swal from 'sweetalert2';
import { TemplateRef } from '@angular/core';

declare var $: any;

export class AsapBaseCRUD {

    public editing = false;
    public saving = false;
    public cumulativeList = false;
    public editDialog;
    public editBootstrap = false;
    public useSwal = false;

    public tableMode;
    public idField = 'id';
    public descriptionField = 'description';
    public descriptionLabel = 'Descrição';
    public imageField = 'Descrição';

    public silent = false;

    public entity = null;
    public list = null;
    public meta = null;

    public loadingList = false;

    public editClass: any = AsapEditComponent;

    constructor(
        public global: Global,
        public service: AsapBaseService
    ) {

    }

    protected displayedColumns() {
        const defs = this.tableDef();
        const result = [];
        for (const def of defs) {
            result.push(def.fieldName);
        }
        result.push('Acao');
        return result;
    }

    protected tableDef() {
        const result = [
            {
                fieldName: this.descriptionField,
                fieldLabel: this.descriptionLabel
            }
        ];
        return result;
    }

    protected actionButtons() {
        const buttons = [
            {
                styleClass: 'btn btn-sm btn-primary',
                color: 'primary',
                content: '<i class="fa fa-pencil-square-o"></i>',
                action: (item) => { this.edit(item); }
            },
            {
                styleClass: 'btn btn-sm btn-danger',
                color: 'accent',
                content: '<i class="fa fa-times"></i>',
                action: (item) => { this.delete(item); }
            },
        ];
        return buttons;
    }

    public message(title, message, type) {
        if (this.useSwal) {
            Swal.fire({
                title,
                text: message,
                type
            });
        }
        else {
            this.global.showNotification(
                message,
                type
            );
        }
    }


    public afterCreate() {
        this.listAll();
    }

    public defaults() {
        return {};
    }

    public listCondition() {
        return {};
    }

    public setEntity(entity) {
        this.entity = entity;
    }

    public canSave(alert = true, container = null) {
        let message = '';
        let invalidDivs = '.ng-invalid';

        if (container) {
            invalidDivs = `#${container} .ng-invalid`;
        }

        const invalid = $(invalidDivs);

        for (let i = 0; i < invalid.length; i++) {
            const element: any = invalid[i];
            if ($(element).attr('placeholder')) {
                if (message != '') { message += ", "; }
                message += $(element).attr('placeholder');
            }
        }
        if (message != '') {
            if (alert) {
                this.message('Erro...', 'Informe os seguintes campos: ' + message, 'warning');
            }
            return false;
        }
        return true;
    }

    public cancel() {
        if (this.editClass instanceof TemplateRef) {
            this.global.dialogClose(this.constructor.name);
        }
        else if (this.editBootstrap) {
            setTimeout(() => {
                $(this.editClass).modal('hide');
            }, 100);
        }
        else if (this.editDialog) {
            this.editDialog.close();
            this.editDialog = null;
        }
        this.entity = null;
    }

    public save(entity, afterSave = null) {
        if (this.canSave()) {
            if (!this.saving) {
                this.saving = true;
                this.global.loading = true;
                setTimeout(() => {
                    if (!entity) { entity = this.entity; }
                    this.service.save(entity).subscribe(
                        (response: any) => {
                            this.editing = false;
                            if (!this.silent) {
                                this.message(
                                    'Salvar!',
                                    'Registro salvo com sucesso!',
                                    'success',
                                );
                            }

                            if (this.editClass instanceof TemplateRef) {
                                this.global.dialogClose(this.constructor.name);
                            }
                            else if (this.editBootstrap) {
                                setTimeout(() => {
                                    $(this.editClass).modal('hide');
                                }, 100);
                            }
                            else if (this.editDialog) {
                                this.editDialog.close();
                                this.editDialog = null;
                            }
                            setTimeout(() => {
                                if (afterSave) { afterSave(response); }
                                this.listAll();
                                this.saving = false;
                                this.global.loading = false;
                            });
                        },
                        (error) => {
                            this.message(
                                'Erro!',
                                error.message,
                                'error',
                            );
                            this.saving = false;
                            this.global.loading = false;
                        }
                    );
                }, 100);
            }
        }
    }

    public openEdit() {
        if (this.editClass instanceof TemplateRef) {
            this.global.dialogOpen(this.editClass, {}, this.constructor.name);
        }
        else if (this.editBootstrap) {
            setTimeout(() => {
                $(this.editClass).modal('show');
            }, 100);
        }
        else {
            this.editDialog = this.global.dialog.open(this.editClass, {
                width: '500px',
                disableClose: true,
                data: { owner: this }
            });
        }
    }

    public add() {
        this.editing = true;
        this.entity = this.defaults();
        this.openEdit();
    }

    public edit(item) {
        console.log("item", item);

        this.global.loading = true;
        this.editing = true;
        this.service.getEntity(item[this.idField]).subscribe((response: any) => {
            if (response.data) {
                this.global.loading = false;
                if (response.data instanceof Array) {
                    this.setEntity(response.data[0]);
                }
                else {
                    this.setEntity(response.data);
                }
            }
            else {
                this.global.loading = false;
                if (response instanceof Array) {
                    this.setEntity(response[0]);
                }
                else {
                    this.setEntity(response);
                }
            }
            this.openEdit();
        });
    }

    public delete(item, afterDelete = null) {
        if (this.silent) {
            this.global.loading = true;
            this.service.delete(item[this.idField]).subscribe(
                (response: any) => {
                    if (afterDelete) { afterDelete(); }
                    const idx = this.list.indexOf(item);
                    if (idx >= 0) {
                        this.list.splice(idx, 1);
                    }
                    this.global.loading = false;
                },
                (error) => {
                    this.global.loading = false;
                    this.message(
                        'Erro!',
                        error.message,
                        'error',
                    );
                }
            );
        }
        else {
            Swal.fire({
                title: 'Remover?',
                text: 'Você tem certeza que deseja remover este registro?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'

            }).then(
                confirm => {
                    if (confirm.value) {
                        this.global.loading = true;
                        this.service.delete(item[this.idField]).subscribe(
                            (response: any) => {
                                if (!this.silent) {
                                    this.message(
                                        'Removido!',
                                        'Registro removido com sucesso!',
                                        'success',
                                    );
                                }
                                if (afterDelete) { afterDelete(); }
                                const idx = this.list.indexOf(item);
                                if (idx >= 0) {
                                    this.list.splice(idx, 1);
                                }
                                this.global.loading = false;
                                this.listAll();
                            },
                            (error) => {
                                this.global.loading = false;
                                this.message(
                                    'Erro!',
                                    error.message,
                                    'error'
                                );
                            }
                        );
                    }
                },
                cancel => { }
            );
        }
    }

    public listAll(page = null, afterListAll = null) {
        this.loadingList = true;
        const condition: any = this.listCondition();
        if (page == null) {
            if (this.cumulativeList) {
                this.list = [];
            }
            page == 1;
        }
        if ((this.meta) && (page != 1)) {
            if (condition.query) {
                if (condition.query != '') { condition.query += "&"; }
                condition.query += 'page=' + page;
            }
            else {
                condition.query = 'page=' + page;
            }
        }
        this.service.listAll(condition).subscribe(
            (response: any) => {
                if (this.cumulativeList) {
                    if (response.data) {
                        this.list = this.list.concat(response.data);
                    }
                    else {
                        this.list = this.list.concat(response);
                    }
                }
                else {
                    if (response.data) {
                        this.list = response.data;
                    }
                    else {
                        this.list = response;
                    }
                }

                this.meta = null;
                if (response.current_page) {
                    this.meta = response;
                }
                else if (response.meta) {
                    this.meta = response.meta.pagination;
                    this.meta.last_page = this.meta.count;
                }
                if (afterListAll) { afterListAll(); }
                this.loadingList = false;
            },
            (error) => {
                this.loadingList = false;
                this.message('Erro ao carregar os dados...', 'Ocorreu um erro ao carregar os Dados, caso você tenha alguma dúvida sobre o ocorrido entre em contato com o Administrador do Sistema!', 'error');
            }
        );
    }

    public title() {
        if (this.entity[this.idField]) {
            return 'Editando #' + this.entity[this.idField];
        }
        else {
            return 'Adicionando...'
        }
    }

    public paginateMenu() {
        const result = [];
        if (this.meta) {
            let page = 1;
            while (page <= this.meta.last_page) {
                result.push(page);
                page++;
                if ((page == 4) && (this.meta.last_page > 6)) {
                    result.push('...');
                    page = this.meta.last_page - 2;
                }
            }
        }
        return result;
    }

    public lookup(list, listField, item, itemField, cacheField) {
        if (!item[cacheField]) {
            const data = list.find(i => i[listField] == item[itemField]);
            if (data) {
                item[cacheField] = data;
            }
        }

        return item[cacheField];
    }

}




// WEBPACK FOOTER //
// ./src/app/@core/lib/asap-base-crud.component.ts